"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7288],{

/***/ 789:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Desktop_Desktop)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/ada/SkipContent/SkipContent.tsx + 2 modules
var SkipContent = __webpack_require__(43383);
// EXTERNAL MODULE: ./src/compositions/LogoLink/LogoLink.tsx
var LogoLink = __webpack_require__(10698);
// EXTERNAL MODULE: ./src/compositions/Header/components/Banner/Banner.tsx + 39 modules
var Banner = __webpack_require__(18223);
// EXTERNAL MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx + 1 modules
var MainHeader = __webpack_require__(45147);
// EXTERNAL MODULE: ./src/compositions/Header/components/InAppMessagesCounter/InAppMessagesCounter.tsx + 2 modules
var InAppMessagesCounter = __webpack_require__(87357);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/Header/components/ChatAssistance/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "birdie"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/ChatAssistance/ChatAssistance.tsx






var ChatAssistance = function() {
    var intl = (0,useIntl/* default */.Z)();
    var label = intl.formatMessage(messages.label);
    (0,react.useEffect)(function() {
        void (0,manager/* preloadModal */.My)("chatAssistanceModal");
    }, []);
    var handleClick = function() {
        (0,manager/* openModal */.h7)("chatAssistanceModal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "cursor-pointer text-white",
        type: "button",
        "aria-label": label,
        "data-testid": "ChatAssistance",
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "24/birdie"
        })
    });
};
/* harmony default export */ const ChatAssistance_ChatAssistance = (ChatAssistance);

// EXTERNAL MODULE: ./src/compositions/Header/components/QueueCounter/QueueCounter.tsx + 1 modules
var QueueCounter = __webpack_require__(58884);
// EXTERNAL MODULE: ./src/compositions/Header/components/Cart/Cart.tsx + 1 modules
var Cart = __webpack_require__(14190);
// EXTERNAL MODULE: ./src/compositions/Header/components/Search/Search.tsx + 1 modules
var Search = __webpack_require__(24324);
// EXTERNAL MODULE: ./src/compositions/Header/components/UserNavWrapper/UserNavWrapper.tsx
var UserNavWrapper = __webpack_require__(50623);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/user/referralProgram/index.ts
var referralProgram = __webpack_require__(2487);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/navigation/NavItem/NavItem.tsx
var NavItem = __webpack_require__(84473);
// EXTERNAL MODULE: ./src/compositions/navigation/messages.ts
var navigation_messages = __webpack_require__(8323);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/SupNav/SupNav.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var SupNav = function() {
    var isLoggedIn = (0,user_user/* useUser */.a)().isLoggedIn;
    var _useReferralInvites = (0,referralProgram/* useReferralInvites */.n)(), available = _useReferralInvites.stats.available;
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    if (!isLoggedIn) {
        return null;
    }
    var getReferralLink = function() {
        var handleClick = function() {
            (0,analytics/* track */.j)("Banner click", {
                placement: "Header",
                content: "Referral program",
                action: "link",
                link: links/* default */.ZP.invite
            });
        };
        if (available) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                className: "flex items-center gap-8",
                to: links/* default */.ZP.invite,
                title: _object_spread_props(_object_spread({}, navigation_messages/* default */.Z.newReferral), {
                    values: {
                        available: available,
                        freeFragranceClassName: "",
                        spanClassName: "bg-white text-black"
                    }
                }),
                style: "p4",
                withArrow: true,
                onClick: handleClick
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gold-30 desktop:z-desktop-sup-header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "flex w-full items-center justify-between py-8",
            children: [
                getReferralLink(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                            className: "inline-block",
                            style: "p4",
                            to: links/* default */.ZP.tracking,
                            title: navigation_messages/* default */.Z.track,
                            onClick: function() {
                                (0,analytics/* track */.j)("Track your order click", {
                                    placement: "Header"
                                });
                            }
                        }),
                        isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                            className: "ml-24 inline-block",
                            style: "p4",
                            to: links/* default */.ZP.queue,
                            title: navigation_messages/* default */.Z.queue,
                            onClick: function() {
                                (0,analytics/* track */.j)("Manage your queue click", {
                                    placement: "Header"
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const SupNav_SupNav = (SupNav);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(73074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/popover/popover.js + 6 modules
var popover = __webpack_require__(21864);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/helpers/modifiers/sanitizeForAnalytics.ts
var sanitizeForAnalytics = __webpack_require__(43615);
// EXTERNAL MODULE: ./src/compositions/navigation/NavList/NavList.tsx
var NavList = __webpack_require__(92124);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/compositions/navigation/NavDivider/NavDivider.tsx



var NavDivider = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,clsx/* default */.Z)("border-solid-gray-80 desktop:h-32", className),
        role: "separator"
    });
};
/* harmony default export */ const NavDivider_NavDivider = (NavDivider);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ./local_modules/links/getLinkWithParams.ts
var getLinkWithParams = __webpack_require__(54780);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var analytics_context = __webpack_require__(5649);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTONavigationData.ts
var useStrapiWSTONavigationData = __webpack_require__(14159);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
// EXTERNAL MODULE: ./src/components/dataDisplay/ExclusiveLabel/ExclusiveLabel.tsx
var ExclusiveLabel = __webpack_require__(31813);
// EXTERNAL MODULE: ./src/compositions/Header/components/ReferralNavItem/ReferralNavItem.tsx
var ReferralNavItem = __webpack_require__(5264);
// EXTERNAL MODULE: ./src/compositions/Header/view/Desktop/components/banners/StrapiWSTONavigationBanner/StrapiWSTONavigationBanner.tsx
var StrapiWSTONavigationBanner = __webpack_require__(98539);
// EXTERNAL MODULE: ./src/modules/banners/useStrapiNavigationBanner.ts + 1 modules
var useStrapiNavigationBanner = __webpack_require__(14762);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx + 2 modules
var TheEditBanner = __webpack_require__(47866);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var Button_messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(76133);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/messages.ts
/* harmony default export */ const BrandsBanner_messages = ({
    perfumes: {
        title: {
            en: '\n        Spotlight on:<br />\n        <span class="text-gold-50">Skylar</span>\n      '
        },
        text: {
            en: "\n        Balancing perfumery with<br />\n        hypoallergenic formulations,<br />\n        Skylar proves that you can have<br />\n        safe, clean scents that smell<br />\n        utterly alluring.\n      "
        }
    },
    colognes: {
        title: {
            en: '\n        Spotlight on:<br />\n        <span class="text-gold-50">Parfums De Marly</span>\n      '
        },
        text: {
            en: "\n        Crafted from a palette of noble<br />\n        ingredients, Parfums de Marly<br />\n        compositions are a meld of lavish<br />\n        18th-century splendor, tailor-<br />\n        made for the pure enjoyment.\n      "
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/images/perfumes.jpg
const perfumes_namespaceObject = __webpack_require__.p + "images/perfumes_8c0311.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/images/colognes.jpg
const colognes_namespaceObject = __webpack_require__.p + "images/colognes_55e0ec.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BrandsBanner/BrandsBanner.tsx








var banners = {
    perfumes: {
        to: (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
            name: "skylar"
        }),
        bgImage: perfumes_namespaceObject,
        messages: BrandsBanner_messages.perfumes,
        brandName: "Skylar"
    },
    colognes: {
        to: (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
            name: "parfums-de-marly"
        }),
        bgImage: colognes_namespaceObject,
        messages: BrandsBanner_messages.colognes,
        brandName: "Parfums de Marly"
    }
};
var BrandsBanner = function(param) {
    var placement = param.placement, onClick = param.onClick;
    var _banners_placement = banners[placement], to = _banners_placement.to, bgImage = _banners_placement.bgImage, messages = _banners_placement.messages, brandName = _banners_placement.brandName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: to,
        title: messages.title,
        text: messages.text,
        textColor: "black",
        bgImage: bgImage,
        buttonTitle: Button_messages/* default */.Z.shopNow,
        content: "Featured brand",
        onClick: onClick,
        trackParams: {
            productBrand: brandName
        },
        "data-testid": "brandsBanner"
    });
};
/* harmony default export */ const BrandsBanner_BrandsBanner = (BrandsBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/messages.ts
/* harmony default export */ const QuizBanner_messages = ({
    title: {
        en: "That scent is so you"
    },
    text: {
        en: "Learn about the fragrance\nfamilies you gravitate towards,\nand find scents that fit your\npreferences."
    },
    takeQuiz: {
        en: "Take the quiz"
    },
    retakeQuiz: {
        en: "Retake the quiz"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_0e3bbc.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/QuizBanner/QuizBanner.tsx







var QuizBanner = function(param) {
    var onClick = param.onClick;
    var hasScentProfile = (0,user_user/* useUser */.a)().hasScentProfile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.smartRecommendations,
        title: QuizBanner_messages.title,
        text: QuizBanner_messages.text,
        bgImage: bg_namespaceObject,
        buttonTitle: hasScentProfile ? QuizBanner_messages.retakeQuiz : QuizBanner_messages.takeQuiz,
        content: "Quiz",
        onClick: onClick,
        "data-testid": "quizBanner"
    });
};
/* harmony default export */ const QuizBanner_QuizBanner = (QuizBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: "The gift that keeps\non giving"
    },
    text: {
        en: "\n      With a Scentbird gift\nsubscription, your recipient\ncan take the lead and choose\nthe all fragrances\n      they want\nto try for a three, six, or\ntwelve-month duration.\n    "
    },
    buttonTitle: {
        en: "Shop gift subscriptions"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/images/bg.jpg
const GiftSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_3ca901.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx






var GiftSubscriptionBanner = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.giftSubscription,
        title: GiftSubscriptionBanner_messages.title,
        text: GiftSubscriptionBanner_messages.text,
        bgImage: GiftSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: GiftSubscriptionBanner_messages.buttonTitle,
        content: "Gift subscription",
        onClick: onClick,
        "data-testid": "giftSubscriptionBanner"
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (GiftSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/messages.ts
/* harmony default export */ const CasesBanner_messages = ({
    title: {
        en: "Pick a color,\nany color"
    },
    text: {
        en: "Available in a variety of hues, our\natomizer cases ensure your scent is\nalways dressed for the occasion."
    },
    buttonTitle: {
        en: "Shop cases"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/images/bg.jpg
const CasesBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_a37e52.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CasesBanner/CasesBanner.tsx






var CasesBanner = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.scentbirdCases,
        title: CasesBanner_messages.title,
        titleColor: "white",
        text: CasesBanner_messages.text,
        textColor: "white",
        bgImage: CasesBanner_images_bg_namespaceObject,
        buttonTitle: CasesBanner_messages.buttonTitle,
        content: "Cases",
        onClick: onClick,
        "data-testid": "casesBanner"
    });
};
/* harmony default export */ const CasesBanner_CasesBanner = (CasesBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DynamicNavigationBanner/DynamicNavigationBanner.tsx









var DynamicNavigationBanner = function(props) {
    var placement = props.placement, onClick = props.onClick;
    var isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    var isStrapiBannersEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.strapiBanners);
    var _useStrapiNavigationBanner = (0,useStrapiNavigationBanner/* default */.Z)({
        placement: placement,
        onClick: onClick,
        skip: !isStrapiBannersEnabled
    }), isFetching = _useStrapiNavigationBanner.isFetching, bannerData = _useStrapiNavigationBanner.bannerData;
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            className: "bg-gray-70",
            h: 296
        });
    }
    if (!isStrapiBannersEnabled || !bannerData) {
        if (placement === "perfumes" || placement === "colognes") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandsBanner_BrandsBanner, {
                placement: placement,
                onClick: onClick
            });
        }
        if (placement === "discover") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizBanner_QuizBanner, {
                onClick: onClick
            });
        }
        if (placement === "gifts") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
                onClick: onClick
            });
        }
        if (placement === "shop") {
            var BannerComponent = isTheEditEnabled ? TheEditBanner/* default */.Z : CasesBanner_CasesBanner;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerComponent, {
                onClick: onClick
            });
        }
        return null;
    }
    if (!bannerData) {
        return null;
    }
    var href = bannerData.isExternalLink ? bannerData.to : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: bannerData.to,
        href: href,
        bgImage: bannerData.bgImage,
        content: null,
        "data-testid": "brandsBanner",
        onClick: onClick,
        trackParams: bannerData.trackParams
    });
};
/* harmony default export */ const DynamicNavigationBanner_DynamicNavigationBanner = (DynamicNavigationBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DriftSubscriptionNavBanner/images/bg.jpg
const DriftSubscriptionNavBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_3b4a5c.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/DriftSubscriptionNavBanner/DriftSubscriptionNavBanner.tsx





var DriftSubscriptionNavBanner = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.driftSubscription,
        bgImage: DriftSubscriptionNavBanner_images_bg_namespaceObject,
        content: "Drift subscription",
        "data-testid": "driftSubscriptionNavBanner",
        onClick: onClick
    });
};
/* harmony default export */ const DriftSubscriptionNavBanner_DriftSubscriptionNavBanner = (DriftSubscriptionNavBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/messages.ts
/* harmony default export */ const CandleSubscriptionBanner_messages = ({
    title: {
        en: "Introducing our\nCandle Club"
    },
    text: {
        en: "\n      Everything is illuminated, thanks to\nour luxe scented candles you'll\nreceive each month. Retailing at up\nto $75, these will light your fire.\n    "
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/images/bg.jpg
const CandleSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_a79560.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CandleSubscriptionBanner/CandleSubscriptionBanner.tsx







var CandleSubscriptionBanner = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.candleSubscription,
        title: CandleSubscriptionBanner_messages.title,
        titleColor: "white",
        text: CandleSubscriptionBanner_messages.text,
        textColor: "white",
        bgImage: CandleSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: Button_messages/* default */.Z.learnMore,
        buttonStyle: "gold-30",
        content: "Candle subscription",
        onClick: onClick,
        "data-testid": "candleSubscriptionBanner"
    });
};
/* harmony default export */ const CandleSubscriptionBanner_CandleSubscriptionBanner = (CandleSubscriptionBanner);

// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/messages.ts
/* harmony default export */ const CaseSubscriptionBanner_messages = ({
    title: {
        en: "Make a case for\nsomething new"
    },
    text: {
        en: "\n      Month after month. Upgrade your\naccount to include a new atomizer\ncase\n      in every order for an extra {price}\nper month, and ensure your scents\nare always covered.\n    "
    },
    buttonTitle: {
        en: "Subscribe to monthly cases"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/images/bg.jpg
const CaseSubscriptionBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_cc3bcd.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/CaseSubscriptionBanner/CaseSubscriptionBanner.tsx
function CaseSubscriptionBanner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CaseSubscriptionBanner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CaseSubscriptionBanner_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CaseSubscriptionBanner_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CaseSubscriptionBanner_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CaseSubscriptionBanner_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var CaseSubscriptionBanner = function(param) {
    var onClick = param.onClick;
    var caseSubscription = (0,subscriptionAddons/* useCaseSubscription */.PZ)().caseSubscription;
    // fallback just in case of re-fetching
    var price = (0,formatPrice/* default */.Z)((caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.price) || 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.caseSubscription,
        title: CaseSubscriptionBanner_messages.title,
        titleColor: "white",
        text: CaseSubscriptionBanner_object_spread_props(CaseSubscriptionBanner_object_spread({}, CaseSubscriptionBanner_messages.text), {
            values: {
                price: price
            }
        }),
        textColor: "white",
        bgImage: CaseSubscriptionBanner_images_bg_namespaceObject,
        buttonTitle: CaseSubscriptionBanner_messages.buttonTitle,
        content: "Case subscription",
        onClick: onClick,
        "data-testid": "caseSubscriptionBanner"
    });
};
/* harmony default export */ const CaseSubscriptionBanner_CaseSubscriptionBanner = (CaseSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/messages.ts
/* harmony default export */ const BuyQueueBanner_messages = ({
    title: {
        en: "Get more and then\nsave more"
    },
    text: {
        en: "\n      Instead of waiting month after\nmonth, buy your entire queue\nand save on the lot.\n      Unlock 5%\nwhen you add three items to\nyour cart, and 10% if you buy six.\n    "
    },
    buttonTitle: {
        en: "Buy your queue and save"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/images/bg.jpg
const BuyQueueBanner_images_bg_namespaceObject = __webpack_require__.p + "images/bg_393d3c.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/banners/BuyQueueBanner/BuyQueueBanner.tsx






var BuyQueueBanner = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.buyQueue,
        title: BuyQueueBanner_messages.title,
        text: BuyQueueBanner_messages.text,
        bgImage: BuyQueueBanner_images_bg_namespaceObject,
        buttonTitle: BuyQueueBanner_messages.buttonTitle,
        content: "Buy your queue",
        onClick: onClick,
        "data-testid": "buyQueueBanner"
    });
};
/* harmony default export */ const BuyQueueBanner_BuyQueueBanner = (BuyQueueBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/util/useDesktopNav.tsx

















var getGiftHubNavigationItemData = function(isHolidayMothersDayEnabled, isHolidayFathersDayEnabled) {
    if (isHolidayMothersDayEnabled) {
        return {
            background: "faded-pink",
            exclusiveLabelVariant: "pink",
            title: navigation_messages/* default */.Z.holidayGiftsMothersDay
        };
    }
    if (isHolidayFathersDayEnabled) {
        return {
            background: "gold-50",
            exclusiveLabelVariant: "gold-50",
            title: navigation_messages/* default */.Z.holidayGiftsFathersDay
        };
    }
    return {
        background: "vinous",
        exclusiveLabelVariant: "gold",
        title: navigation_messages/* default */.Z.gifts
    };
};
var useDesktopNav = function() {
    var _strapiWSTONavigationData_banners, _strapiWSTONavigationData_banners1, _strapiWSTONavigationData_banners2, _subscription_stateOptions;
    var isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    var isTheShopEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theShop);
    var isCandleSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleSubscription);
    var isFragranceFamiliesPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.fragranceFamiliesPage);
    var isNotesLibraryPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.noteLibPages);
    var isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    var isGiftHubEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHub);
    var isHolidayMothersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayMothersDay);
    var isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    var isScentHoroscopeEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentHoroscope);
    var isShopSamplesEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.shopSamples);
    var isScentbirdPodcastEntryPointsEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentbirdPodcastEntryPoints);
    var isTravelSizeEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.travelSizeFragrances);
    var isDriftEcommercePromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftEcommercePromo);
    var isMemorialSaleLabelEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.memorialSale);
    var isCOARShopPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.coarShopPage);
    var isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    var isScentbirdAcademyEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentbirdAcademy);
    var isGiftsUnder50PageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftsUnder50Page);
    var isBuy5pay4Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.buy5pay4);
    var _useUser = (0,user_user/* useUser */.a)(), gender = _useUser.gender, hasScentProfile = _useUser.hasScentProfile;
    var strapiWSTONavigationData = (0,useStrapiWSTONavigationData/* default */.Z)();
    var isStrapiWSTONavigationDataEnabled = Boolean(strapiWSTONavigationData);
    var isStrapiWSTONavigationPerfumesBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners.perfumes);
    var isStrapiWSTONavigationColognesBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners1 = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners1 === void 0 ? void 0 : _strapiWSTONavigationData_banners1.colognes);
    var isStrapiWSTONavigationDiscoverBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners2 = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners2 === void 0 ? void 0 : _strapiWSTONavigationData_banners2.discover);
    var privateSale = (0,usePrivateSale/* default */.Z)().privateSale;
    var isPrivateSaleEnabled = Boolean(privateSale);
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    var isBuyQueueEnabled = subscription === null || subscription === void 0 ? void 0 : (_subscription_stateOptions = subscription.stateOptions) === null || _subscription_stateOptions === void 0 ? void 0 : _subscription_stateOptions.canBuyQueue;
    var canApplyTossInOffer = subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer;
    var caseSubscription = (0,subscriptionAddons/* useCaseSubscription */.PZ)().caseSubscription;
    var isCaseSubscriptionEnabled = caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled;
    var isCaseSubscriptionSelected = caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected;
    var candleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)().candleSubscription;
    var isCandleSubscriptionSelected = candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected;
    var isCandleSubscriptionVisible = Boolean(isCandleSubscriptionEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled));
    var driftSubscription = (0,subscriptionAddons/* useDriftSubscription */.RD)().driftSubscription;
    var isDriftSubscriptionSelected = driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected;
    var isDriftSubscriptionVisible = Boolean(isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled));
    var _useReferralInvites = (0,referralProgram/* useReferralInvites */.n)(), available = _useReferralInvites.stats.available;
    var isReferralItemVisible = Boolean(available);
    var isTopLevelCandleClubEntryPointVisible = isCandleSubscriptionVisible && !isCandleSubscriptionSelected;
    var discoverSectionBanner = isStrapiWSTONavigationDiscoverBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    var perfumesSectionBanner = isStrapiWSTONavigationPerfumesBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    var colognesSectionBanner = isStrapiWSTONavigationColognesBannerExists ? StrapiWSTONavigationBanner/* default */.Z : DynamicNavigationBanner_DynamicNavigationBanner;
    var isUpgradeEntryPointsEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upgradeEntryPoints) === "b" && (subscription === null || subscription === void 0 ? void 0 : subscription.isUpgradableFromMonthlyPlan);
    var isScentHoroscopeInPerfumesEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.navScentHoroscopeInPerfumes) === "b";
    var isRecommendedForYouLinkEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.recommendedForYouNavLink) === "b";
    var recommendedForYouItem = {
        id: "recommended-for-you",
        title: navigation_messages/* default */.Z.recommendedForYou,
        to: links/* default */.ZP.scentProfile
    };
    return (0,react.useMemo)(function() {
        var giftHubNavigationItemData = isGiftHubEnabled ? getGiftHubNavigationItemData(isHolidayMothersDayEnabled, isHolidayFathersDayEnabled) : null;
        var onFragranceMenuDisplay = function() {
            var context = (0,analytics_context/* getAnalyticsContext */.cV)();
            if (context.subscriptionStatus !== "LEAD") {
                (0,analytics/* trackOnce */.Cn)("Fragrances menu display");
            }
        };
        var collaborationItem = isSaksCollaborationEnabled && {
            id: "header-discover-scentbird-select",
            title: navigation_messages/* default */.Z.scentbirdSelect,
            to: links/* default */.ZP.scentbirdSelect,
            label: navigation_messages/* default */.Z.labels["new"]
        };
        var data = [
            {
                id: "perfumes",
                title: navigation_messages/* default */.Z.perfumes,
                list: [
                    {
                        id: "perfumes-all",
                        title: navigation_messages/* default */.Z.allPerfumes,
                        to: links/* default */.ZP.subscription.perfumes
                    },
                    isRecommendedForYouLinkEnabled && gender === "MALE" && recommendedForYouItem,
                    collaborationItem,
                    isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    {
                        id: "perfumes-new-arrivals",
                        title: navigation_messages/* default */.Z.newArrivals,
                        to: links/* default */.ZP.newArrivals.perfumes
                    },
                    {
                        id: "perfumes-bestsellers",
                        title: navigation_messages/* default */.Z.bestsellers,
                        to: links/* default */.ZP.bestsellers.perfumes
                    },
                    {
                        id: "perfumes-pom",
                        title: navigation_messages/* default */.Z.pom,
                        to: links/* default */.ZP.subscription.currentPerfumeOfTheMonth
                    },
                    {
                        id: "perfumes-clean",
                        title: navigation_messages/* default */.Z.clean,
                        to: links/* default */.ZP.clean.perfumes
                    },
                    {
                        id: "perfumes-exclusive",
                        title: navigation_messages/* default */.Z.exclusive,
                        to: "".concat(links/* default */.ZP.subscription.perfumes, "?category=exclusive")
                    },
                    {
                        id: "perfumes-collections",
                        title: navigation_messages/* default */.Z.collections,
                        to: links/* default */.ZP.collectionsWomen
                    },
                    {
                        id: "header-discover-allBrands",
                        title: navigation_messages/* default */.Z.allBrands,
                        to: links/* default */.ZP.brands
                    }
                ].filter(Boolean),
                withColumns: true,
                bannerComponent: perfumesSectionBanner,
                onDisplay: onFragranceMenuDisplay
            },
            {
                id: "colognes",
                title: navigation_messages/* default */.Z.colognes,
                list: [
                    {
                        id: "colognes-all",
                        title: navigation_messages/* default */.Z.allColognes,
                        to: links/* default */.ZP.subscription.colognes
                    },
                    isRecommendedForYouLinkEnabled && gender === "FEMALE" && recommendedForYouItem,
                    collaborationItem,
                    isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    {
                        id: "colognes-new-arrivals",
                        title: navigation_messages/* default */.Z.newArrivals,
                        to: links/* default */.ZP.newArrivals.colognes
                    },
                    {
                        id: "colognes-bestsellers",
                        title: navigation_messages/* default */.Z.bestsellers,
                        to: links/* default */.ZP.bestsellers.colognes
                    },
                    {
                        id: "colognes-com",
                        title: navigation_messages/* default */.Z.com,
                        to: links/* default */.ZP.subscription.currentCologneOfTheMonth
                    },
                    {
                        id: "colognes-clean",
                        title: navigation_messages/* default */.Z.clean,
                        to: links/* default */.ZP.clean.colognes
                    },
                    {
                        id: "colognes-exclusive",
                        title: navigation_messages/* default */.Z.exclusive,
                        to: "".concat(links/* default */.ZP.subscription.colognes, "?category=exclusive")
                    },
                    {
                        id: "colognes-collections",
                        title: navigation_messages/* default */.Z.collections,
                        to: links/* default */.ZP.collectionsMen
                    },
                    {
                        id: "header-discover-allBrands",
                        title: navigation_messages/* default */.Z.allBrands,
                        to: links/* default */.ZP.brands
                    }
                ].filter(Boolean),
                withColumns: true,
                bannerComponent: colognesSectionBanner,
                onDisplay: onFragranceMenuDisplay
            },
            {
                id: "beauty",
                title: navigation_messages/* default */.Z.beauty,
                to: links/* default */.ZP.subscription.beauty
            },
            isUpgradeEntryPointsEnabled && {
                id: "header-upgrade",
                title: navigation_messages/* default */.Z.upgrade2Scents,
                to: links/* default */.ZP.upgradeProduct
            },
            !isUpgradeEntryPointsEnabled && isTopLevelCandleClubEntryPointVisible && {
                id: "candleClub",
                title: navigation_messages/* default */.Z.candleSubscription,
                to: links/* default */.ZP.candleSubscription
            },
            {
                isDivider: true
            },
            {
                id: "shop",
                title: navigation_messages/* default */.Z.shop,
                list: [
                    isGiftHubEnabled && {
                        id: "header-gift-hub",
                        title: giftHubNavigationItemData.title,
                        to: links/* default */.ZP.gifts
                    },
                    isGiftsUnder50PageEnabled && {
                        id: "header-giftsUnder50",
                        title: navigation_messages/* default */.Z.giftsUnder50,
                        to: links/* default */.ZP.giftsUnder50
                    },
                    isDriftEcommercePromoEnabled && {
                        id: "header-drift-ecommerce-promo",
                        title: navigation_messages/* default */.Z.driftEcommercePromo,
                        to: "".concat((0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
                            name: "drift"
                        }), "?productInputSource=THE_EDIT&sourceProductGroup=GiftSet"),
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    isTravelSizeEnabled && {
                        id: "header-shop-travelSizeFragrances",
                        title: navigation_messages/* default */.Z.travelSizeFragrances,
                        to: gender === "FEMALE" ? links/* default */.ZP.shop.travelSize.perfumes : links/* default */.ZP.shop.travelSize.colognes,
                        label: isBuy5pay4Enabled ? navigation_messages/* default */.Z.labels.sale : undefined
                    },
                    isShopSamplesEnabled && {
                        id: "header-shop-samples",
                        title: navigation_messages/* default */.Z.samples,
                        to: links/* default */.ZP.shop.samples.root
                    },
                    isScentbirdAcademyEnabled && {
                        id: "header-scentbird-academy",
                        title: navigation_messages/* default */.Z.scentbirdAcademy,
                        to: links/* default */.ZP.academy.root,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    isTheShopEnabled && {
                        id: "header-shop-fullSizeFragrances",
                        title: navigation_messages/* default */.Z.fullSizeFragrances,
                        to: gender === "FEMALE" ? links/* default */.ZP.shop.perfumes : links/* default */.ZP.shop.colognes,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale
                    },
                    isCOARShopPageEnabled && {
                        id: "header-shop-coar",
                        title: navigation_messages/* default */.Z.coarShopPage,
                        to: links/* default */.ZP.shop.coar,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    isTheEditEnabled && {
                        id: "header-shop-edit",
                        title: navigation_messages/* default */.Z.edit,
                        to: links/* default */.ZP.shop.theEdit,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale
                    },
                    isTheShopEnabled && {
                        id: "header-shop-candlesHomeScents",
                        title: navigation_messages/* default */.Z.candlesHomeScents,
                        to: links/* default */.ZP.shop.candlesHomeScents,
                        label: isMemorialSaleLabelEnabled && navigation_messages/* default */.Z.labels.sale
                    },
                    {
                        id: "header-shop-scentbirdCases",
                        title: navigation_messages/* default */.Z.scentbirdCases,
                        to: links/* default */.ZP.shop.scentbirdCases
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: true,
                bannerComponent: DynamicNavigationBanner_DynamicNavigationBanner
            },
            {
                id: "discover",
                title: navigation_messages/* default */.Z.discover,
                list: [
                    {
                        id: "header-discover-scentProfile",
                        title: navigation_messages/* default */.Z.scentProfile,
                        to: hasScentProfile ? links/* default */.ZP.scentProfile : links/* default */.ZP.smartRecommendations
                    },
                    isStrapiWSTONavigationDataEnabled && {
                        id: "header-discover-featuredBrand",
                        title: navigation_messages/* default */.Z.featuredBrand,
                        to: strapiWSTONavigationData.navLink
                    },
                    !isScentHoroscopeInPerfumesEnabled && isScentHoroscopeEnabled && {
                        id: "header-discover-scentHoroscope",
                        title: navigation_messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    {
                        id: "header-discover-fomArchive",
                        title: navigation_messages/* default */.Z.fomArchive,
                        to: links/* default */.ZP.subscription.perfumeOfTheMonthList
                    },
                    isScentbirdAcademyEnabled && {
                        id: "header-scentbird-academy",
                        title: navigation_messages/* default */.Z.scentbirdAcademy,
                        to: links/* default */.ZP.academy.root,
                        label: navigation_messages/* default */.Z.labels["new"]
                    },
                    isNotesLibraryPageEnabled && {
                        id: "header-discover-notesLibrary",
                        title: navigation_messages/* default */.Z.notesLibrary,
                        to: links/* default */.ZP.notes
                    },
                    isFragranceFamiliesPageEnabled && {
                        id: "header-discover-fragranceFamilies",
                        title: navigation_messages/* default */.Z.fragranceFamilies,
                        to: links/* default */.ZP.fragranceFamilies
                    },
                    {
                        id: "header-discover-scentBlog",
                        title: navigation_messages/* default */.Z.scentBlog,
                        toTab: links/* default */.ZP.blog
                    },
                    isScentbirdPodcastEntryPointsEnabled && {
                        id: "header-discover-podcast",
                        title: navigation_messages/* default */.Z.scentWorldPodcast,
                        href: constants/* default */.Z.externalLinks.scentbirdPodcast,
                        label: navigation_messages/* default */.Z.labels["new"]
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: true,
                bannerComponent: discoverSectionBanner,
                onDisplay: function() {
                    var context = (0,analytics_context/* getAnalyticsContext */.cV)();
                    if (context.subscriptionStatus !== "LEAD") {
                        (0,analytics/* trackOnce */.Cn)("Discover menu display");
                    }
                }
            },
            isSubscribed && {
                id: "member perks",
                title: navigation_messages/* default */.Z.memberPerks,
                list: [
                    isDriftSubscriptionVisible && {
                        id: "header-member-perks-driftSubscription",
                        title: navigation_messages/* default */.Z.driftSubscription,
                        to: links/* default */.ZP.driftSubscription,
                        label: isDriftSubscriptionSelected ? navigation_messages/* default */.Z.labels.subscribed : navigation_messages/* default */.Z.labels["new"]
                    },
                    isBuyQueueEnabled && {
                        id: "header-member-perks-buyYourQueue",
                        title: navigation_messages/* default */.Z.buyYourQueue,
                        to: links/* default */.ZP.buyQueue
                    },
                    isPrivateSaleEnabled && {
                        id: "header-member-perks-privateSale",
                        title: navigation_messages/* default */.Z.privateSale,
                        to: links/* default */.ZP.privateSale
                    },
                    isReferralItemVisible && {
                        id: "referral-nav-item",
                        to: links/* default */.ZP.invite,
                        title: navigation_messages/* default */.Z.referralProgram,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferralNavItem/* default */.Z, {
                            spanClassName: "text-white bg-gold-70 text-p4",
                            freeFragranceClassName: "text-gold-70"
                        })
                    },
                    canApplyTossInOffer && {
                        id: "header-member-perks-lastMinuteAddons",
                        title: navigation_messages/* default */.Z.lastMinuteAddons,
                        to: links/* default */.ZP.tossIn
                    },
                    isCaseSubscriptionEnabled && {
                        id: "header-member-perks-caseSubscription",
                        title: navigation_messages/* default */.Z.caseSubscription,
                        to: links/* default */.ZP.caseSubscription
                    },
                    isCandleSubscriptionVisible && {
                        id: "header-member-perks-candleSubscription",
                        title: navigation_messages/* default */.Z.candleSubscription,
                        to: links/* default */.ZP.candleSubscription,
                        label: isCandleSubscriptionSelected ? navigation_messages/* default */.Z.labels.subscribed : navigation_messages/* default */.Z.labels["new"]
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                withColumns: false,
                bannerComponent: function(param) {
                    var onClick = param.onClick;
                    if (isDriftSubscriptionVisible && !isDriftSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionNavBanner_DriftSubscriptionNavBanner, {
                            onClick: onClick
                        });
                    }
                    if (isCandleSubscriptionVisible && !isCandleSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscriptionBanner_CandleSubscriptionBanner, {
                            onClick: onClick
                        });
                    }
                    if (isCaseSubscriptionEnabled && !isCaseSubscriptionSelected) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseSubscriptionBanner_CaseSubscriptionBanner, {
                            onClick: onClick
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyQueueBanner_BuyQueueBanner, {
                        onClick: onClick
                    });
                }
            },
            {
                id: "gifts",
                title: navigation_messages/* default */.Z.gifts,
                list: [
                    isGiftHubEnabled && {
                        id: "header-gift-hub",
                        title: giftHubNavigationItemData.title,
                        to: links/* default */.ZP.gifts,
                        exclusiveLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclusiveLabel/* default */.Z, {
                            labelText: navigation_messages/* default */.Z.exclusives,
                            variant: giftHubNavigationItemData.exclusiveLabelVariant
                        })
                    },
                    {
                        id: "header-gifts-subscription",
                        title: navigation_messages/* default */.Z.giftSubscription,
                        to: links/* default */.ZP.giftSubscription
                    },
                    isGiftsUnder50PageEnabled && {
                        id: "header-gifts-giftsUnder50",
                        title: navigation_messages/* default */.Z.giftsUnder50,
                        to: links/* default */.ZP.giftsUnder50
                    },
                    {
                        id: "header-gifts-card",
                        title: navigation_messages/* default */.Z.giftCard,
                        to: links/* default */.ZP.giftCard
                    },
                    {
                        id: "header-gift-sets",
                        title: navigation_messages/* default */.Z.giftSets,
                        to: links/* default */.ZP.giftSets.root
                    },
                    !isGiftHubEnabled && {
                        id: "header-gifts",
                        title: navigation_messages/* default */.Z.allGifts,
                        to: links/* default */.ZP.gifts
                    }
                ].filter(Boolean),
                subNavLinksPosition: "right",
                background: giftHubNavigationItemData === null || giftHubNavigationItemData === void 0 ? void 0 : giftHubNavigationItemData.background,
                withColumns: false,
                bannerComponent: DynamicNavigationBanner_DynamicNavigationBanner
            }
        ];
        return data.filter(Boolean);
    }, [
        gender,
        hasScentProfile,
        discoverSectionBanner,
        isGiftHubEnabled,
        isStrapiWSTONavigationDataEnabled,
        strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : strapiWSTONavigationData.navLink,
        isTheEditEnabled,
        isBuyQueueEnabled,
        canApplyTossInOffer,
        isCandleSubscriptionVisible,
        isCandleSubscriptionSelected,
        isCaseSubscriptionEnabled,
        isCaseSubscriptionSelected,
        isFragranceFamiliesPageEnabled,
        isNotesLibraryPageEnabled,
        isSubscribed,
        isTheShopEnabled,
        isPrivateSaleEnabled,
        isTopLevelCandleClubEntryPointVisible,
        isSaksCollaborationEnabled,
        isScentHoroscopeEnabled,
        isHolidayMothersDayEnabled,
        isHolidayFathersDayEnabled,
        isShopSamplesEnabled,
        isScentbirdPodcastEntryPointsEnabled,
        isReferralItemVisible,
        perfumesSectionBanner,
        colognesSectionBanner,
        isUpgradeEntryPointsEnabled,
        isTravelSizeEnabled,
        isDriftEcommercePromoEnabled,
        isMemorialSaleLabelEnabled,
        isCOARShopPageEnabled,
        isScentHoroscopeInPerfumesEnabled,
        isDriftSubscriptionVisible,
        isDriftSubscriptionSelected,
        isScentbirdAcademyEnabled,
        isGiftsUnder50PageEnabled,
        isBuy5pay4Enabled
    ]);
};
/* harmony default export */ const util_useDesktopNav = (useDesktopNav);

// EXTERNAL MODULE: ./src/components/navigation/HoverablePopover/HoverablePopover.tsx + 3 modules
var HoverablePopover = __webpack_require__(87129);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/NavRootItem/NavRootItem.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const NavRootItem_module = ({"activeButton":"cXgL6n"});
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/NavRootItem/NavRootItem.tsx
function NavRootItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var backgroundToClassName = {
    "faded-pink": "bg-faded-pink",
    "gold-50": "bg-gold-50",
    vinous: "bg-vinous"
};
var NavRootItem = function(props) {
    var className = props.className, data = props.data, style = props.style, color = props.color, background = props.background, hoverColor = props.hoverColor, activeColor = props.activeColor, isActive = props.isActive, popoverPanelClassName = props.popoverPanelClassName, groupOpenedPopoverCountRef = props.groupOpenedPopoverCountRef, dataTestId = props["data-testid"];
    var id = data.id, sectionTitle = data.title, list = data.list, subNavLinksPosition = data.subNavLinksPosition, withColumns = data.withColumns, bannerComponent = data.bannerComponent, onDisplay = data.onDisplay;
    var intl = (0,useIntl/* default */.Z)();
    var formattedTitle = intl.formatMessage(sectionTitle);
    var _obj;
    var buttonClassNames = (0,clsx/* default */.Z)(className, "flex cursor-pointer items-center", backgroundToClassName[background], (_obj = {}, NavRootItem_define_property(_obj, "text-".concat(style), style), NavRootItem_define_property(_obj, "hover:text-".concat(hoverColor), hoverColor), NavRootItem_define_property(_obj, "text-".concat(color), color && !isActive), NavRootItem_define_property(_obj, "text-".concat(activeColor), activeColor && isActive), _obj));
    var isColumnFlowEnabled = withColumns && list.length > 5;
    /*
   rearrange items to split them into 2 columns like:
   0 3
   1 4
   2 5
   will be represented as [ 0, 3, 1, 4, 2, 5 ] array
   it is required to split by items count, not items content to provide more control
   */ var itemsByColumns = isColumnFlowEnabled ? list.map(function(_, index) {
        var halfLength = Math.ceil(list.length / 2);
        var halfIndex = Math.floor(index / 2);
        return list[index % 2 * halfLength + halfIndex];
    }) : list;
    var isMenuOnRightSide = subNavLinksPosition === "right";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z, {
        className: "flex items-stretch",
        groupOpenedPopoverCountRef: groupOpenedPopoverCountRef,
        children: function(param) {
            var open = param.open, close = param.close;
            var _obj;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Button, {
                        className: (0,clsx/* default */.Z)(buttonClassNames, (_obj = {}, NavRootItem_define_property(_obj, NavRootItem_module.activeButton, open), NavRootItem_define_property(_obj, "text-".concat(activeColor), open && activeColor), _obj)),
                        "data-testid": dataTestId,
                        children: formattedTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Overlay, {
                        withDefaultStyle: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Panel, {
                        className: (0,clsx/* default */.Z)(popoverPanelClassName, "absolute left-0 top-full z-10 w-full bg-white py-24 text-black"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                            className: (0,clsx/* default */.Z)("flex items-start", isMenuOnRightSide && "flex-row-reverse"),
                            children: [
                                Boolean(onDisplay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayTracker, {
                                    onDisplay: onDisplay
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1 px-24",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "list",
                                        className: (0,clsx/* default */.Z)(isMenuOnRightSide ? "mx-auto w-[400rem]" : "ml-auto w-[384rem]", isColumnFlowEnabled && "grid grid-cols-2 gap-x-16"),
                                        children: itemsByColumns.map(function(param) {
                                            var id = param.id, title = param.title, to = param.to, href = param.href, toTab = param.toTab, label = param.label, content = param.content, exclusiveLabel = param.exclusiveLabel, highlight = param.highlight;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                                                    className: (0,clsx/* default */.Z)("inline-block py-10", highlight && "font-bold"),
                                                    title: title,
                                                    to: to,
                                                    href: href,
                                                    toTab: toTab,
                                                    label: label,
                                                    content: content,
                                                    exclusiveLabel: exclusiveLabel,
                                                    style: "p2",
                                                    color: highlight ? "gold-70" : "black",
                                                    hoverColor: "gold-30",
                                                    activeColor: "gold-30",
                                                    onClick: function() {
                                                        (0,analytics/* track */.j)("Desktop navigation menu click", {
                                                            blockName: (0,sanitizeForAnalytics/* default */.Z)(typeof sectionTitle === "string" ? sectionTitle : sectionTitle.en),
                                                            title: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                                                            link: to || toTab || href
                                                        });
                                                        close();
                                                    },
                                                    "data-testid": id
                                                })
                                            }, id);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[560rem] flex-none",
                                    children: bannerComponent ? /*#__PURE__*/ react.createElement(bannerComponent, {
                                        placement: id,
                                        onClick: close
                                    }) : null
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var DisplayTracker = function(param) {
    var onDisplay = param.onDisplay;
    (0,react.useEffect)(function() {
        onDisplay();
    }, [
        onDisplay
    ]);
    return null;
};
/* harmony default export */ const NavRootItem_NavRootItem = (/*#__PURE__*/react.memo(NavRootItem));

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/Nav/Nav.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}















var Nav = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 1), searchParams = _useSearchParams[0];
    var items = util_useDesktopNav();
    var groupOpenedPopoverCountRef = (0,react.useRef)(0);
    var activeTabLink = "tab" in searchParams ? "".concat(pathname, "?tab=").concat(searchParams.tab) : pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J.Group, {
        as: NavList/* default */.Z,
        className: "ml-32 flex flex-1 items-stretch self-stretch",
        listClassName: "flex items-stretch",
        "aria-label": "Main",
        children: items.map(function(item) {
            if ("isDivider" in item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDivider_NavDivider, {
                    className: "mx-12 self-center"
                }, "divider");
            }
            var id = item.id, title = item.title, to = item.to, list = item.list, content = item.content;
            var isActive = to === activeTabLink || (list === null || list === void 0 ? void 0 : list.some(function(param) {
                var to = param.to;
                return(// this check required because we have different approach to pages with tabs:
                // - same pathname with tabs in perfumes/colognes subNav
                // - only pathname without tabs (but page has tabs), e.g. discover/brands
                (to === null || to === void 0 ? void 0 : to.includes("?tab")) ? to === activeTabLink : to === pathname);
            }));
            if (list) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex items-stretch",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavRootItem_NavRootItem, {
                        className: "px-12",
                        style: "p2",
                        color: "white",
                        hoverColor: "gold-30",
                        activeColor: "gold-30",
                        data: item,
                        background: item.background,
                        groupOpenedPopoverCountRef: groupOpenedPopoverCountRef,
                        "data-testid": id
                    })
                }, id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "flex items-stretch px-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                    className: "flex items-center",
                    style: "p2",
                    color: "white",
                    content: content,
                    hoverColor: "gold-30",
                    activeColor: "gold-30",
                    to: to,
                    title: title,
                    isActive: isActive,
                    onClick: function() {
                        (0,analytics/* track */.j)("Desktop navigation menu click", {
                            blockName: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                            title: (0,sanitizeForAnalytics/* default */.Z)(typeof title === "string" ? title : title.en),
                            link: to
                        });
                    },
                    "data-testid": id
                })
            }, id);
        })
    });
};
/* harmony default export */ const Nav_Nav = (Nav);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.21.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(34020);
// EXTERNAL MODULE: ./src/components/dataDisplay/Avatar/Avatar.tsx + 1 modules
var Avatar = __webpack_require__(20487);
// EXTERNAL MODULE: ./src/compositions/Header/util/useUserNav.tsx
var useUserNav = __webpack_require__(6935);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/UserNav/components/Section/Section.tsx







var Section = function(param) {
    var data = param.data, closeNav = param.closeNav;
    var pathname = (0,contexts/* usePathname */.jD)();
    var sectionTitle = data.title, list = data.list;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: sectionTitle,
                style: "h8",
                color: "gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mb-24 mt-8 text-white",
                children: list.map(function(param) {
                    var id = param.id, title = param.title, label = param.label, to = param.to, toTab = param.toTab, content = param.content, onClick = param.onClick;
                    var handleClick = function(event) {
                        closeNav();
                        (0,analytics/* track */.j)("Desktop profile menu click", {
                            link: to,
                            title: typeof title === "string" ? title : title.en,
                            blockName: typeof sectionTitle === "string" ? sectionTitle : sectionTitle.en
                        });
                        if (typeof onClick === "function") {
                            onClick(event);
                        }
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                        className: "block py-12",
                        title: title,
                        label: label,
                        to: to,
                        toTab: toTab,
                        content: content,
                        style: "p2",
                        hoverColor: "gold-30",
                        activeColor: "gold-30",
                        labelColor: "gold-30",
                        isActive: pathname === to,
                        "data-testid": id,
                        onClick: handleClick
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ const Section_Section = (/*#__PURE__*/react.memo(Section));

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/components/UserNav/UserNav.tsx












var UserNav = function() {
    var sections = (0,useUserNav/* default */.Z)();
    var isAaTestUserNav = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.aaUserNav);
    var user = (0,user_user/* useUser */.a)().user;
    var firstName = user === null || user === void 0 ? void 0 : user.firstName;
    var lastName = user === null || user === void 0 ? void 0 : user.lastName;
    var intl = (0,useIntl/* default */.Z)();
    var buttonAriaLabel = intl.formatMessage(navigation_messages/* default */.Z.aria.profileButton);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z, {
        className: "align-center relative flex h-full justify-center",
        children: function(param) {
            var open = param.open, close = param.close;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Button, {
                        "data-testid": "profileMenuBtn",
                        "aria-label": buttonAriaLabel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            firstName: firstName,
                            lastName: lastName,
                            size: 40,
                            isActive: open,
                            "data-testid": "userAvatar"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverablePopover/* default */.Z.Panel, {
                        as: "nav",
                        className: "absolute right-0 bg-black pr-40 pt-32 text-right desktop:top-full desktop:w-[368rem]",
                        "aria-label": "Profile",
                        children: sections.map(function(data) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_Section, {
                                data: data,
                                closeNav: close
                            }, data.id);
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ const UserNav_UserNav = (/*#__PURE__*/react.memo(UserNav));

;// CONCATENATED MODULE: ./src/compositions/Header/view/Desktop/Desktop.tsx






var Desktop = function(props) {
    var _props_withBanner = props.withBanner, withBanner = _props_withBanner === void 0 ? true : _props_withBanner, _props_withSupNav = props.withSupNav, withSupNav = _props_withSupNav === void 0 ? true : _props_withSupNav, withInAppMessagesCounter = props.withInAppMessagesCounter, withQueueCounter = props.withQueueCounter, loginWithBackRedirect = props.loginWithBackRedirect, logoLink = props.logoLink, withChatAssistance = props.withChatAssistance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipContent/* default */.Z, {
                contentId: "main"
            }),
            withBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {}),
            withSupNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupNav_SupNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainHeader/* default */.Z, {
                size: withQueueCounter ? 1312 : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink/* default */.Z, {
                        color: "white",
                        to: logoLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-flow-col items-center gap-8",
                        children: [
                            withInAppMessagesCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(InAppMessagesCounter/* default */.Z, {}),
                            withChatAssistance && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatAssistance_ChatAssistance, {}),
                            withQueueCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(QueueCounter/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNavWrapper/* default */.Z, {
                                withRedirect: loginWithBackRedirect,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNav_UserNav, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Desktop_Desktop = (Desktop);


/***/ }),

/***/ 10698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69541);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91339);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1041);








var LogoLink = function(props) {
    var className = props.className, customLink = props.to, color = props.color;
    var subscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .m)().subscription;
    var defaultLink = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    var to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: function() {
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 76133:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78364);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66226);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17696);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26713);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85808);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31627);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23796);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73358);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var BannerBase = function(props) {
    var tmp = props["data-testid"], dataTestId = tmp === void 0 ? "banner" : tmp, bgImage = props.bgImage, buttonStyle = props.buttonStyle, buttonTitle = props.buttonTitle, content = props.content, logo = props.logo, logoClassName = props.logoClassName, onClick = props.onClick, text = props.text, textColor = props.textColor, title = props.title, titleClassName = props.titleClassName, titleColor = props.titleColor, to = props.to, toTab = props.toTab, href = props.href, _props_placement = props.placement, placement = _props_placement === void 0 ? "Desktop navigation menu" : _props_placement, _props_trackParams = props.trackParams, trackParams = _props_trackParams === void 0 ? {} : _props_trackParams, caption = props.caption, _props_height = props.height, height = _props_height === void 0 ? 296 : _props_height;
    var handleClick = function() {
        (0,analytics__WEBPACK_IMPORTED_MODULE_3__/* .track */ .j)("Banner click", _object_spread({
            placement: placement,
            content: content,
            link: to,
            action: "link"
        }, trackParams));
        if (typeof onClick === "function") {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        to: to,
        href: href,
        toTab: toTab,
        onClick: handleClick,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "flex flex-col items-start justify-center bg-gray-70 p-32",
            src: bgImage,
            quality: 90,
            style: {
                backgroundPosition: "0 50%",
                height: "".concat(height, "rem")
            },
            children: [
                Boolean(logo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: logoClassName,
                    src: logo
                }),
                Boolean(title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    className: (0,classnames__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("whitespace-pre-line", titleClassName),
                    style: "h7",
                    color: titleColor,
                    message: title,
                    html: true
                }),
                Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: textColor,
                    message: text,
                    html: true
                }),
                Boolean(buttonTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: "mt-16",
                    title: buttonTitle,
                    size: 48,
                    style: buttonStyle,
                    tabIndex: -1,
                    width: 240
                }),
                Boolean(caption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figcaption", {
                    className: "visually-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        value: caption
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BannerBase);


/***/ }),

/***/ 39450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeaderBannerContainer_HeaderBannerContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(52493);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HeaderBannerContainer_module = ({"root":"DB633S"});
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx







var heightClassMap = {
    48: "h-48",
    56: "h-56",
    64: "h-64"
};
var HeaderBannerContainer = function(props) {
    var children = props.children, className = props.className, to = props.to, height = props.height, loading = props.loading, trackParams = props.trackParams, onClick = props.onClick, dataTestId = props["data-testid"];
    var rootClassName = (0,clsx/* default */.Z)(className, HeaderBannerContainer_module.root, "flex items-center justify-center text-white", heightClassMap[height]);
    var content = loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "32/loader"
    }) : children;
    if (to || onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            className: (0,clsx/* default */.Z)(rootClassName, "w-full"),
            to: to,
            role: "complementary",
            loading: loading,
            onClick: function() {
                (0,analytics/* track */.j)("Banner click", trackParams);
                if (typeof onClick === "function") {
                    onClick();
                }
            },
            "data-testid": dataTestId,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        role: "complementary",
        children: content
    });
};
/* harmony default export */ const HeaderBannerContainer_HeaderBannerContainer = (HeaderBannerContainer);


/***/ }),

/***/ 16411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBanner_SubscribeHeaderBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx + 3 modules
var SubscribeHeaderBannerBase = __webpack_require__(23235);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBanner/messages.ts
/* harmony default export */ const messages = ({
    discount: {
        mobile: {
            en: "Get {discount} off your first month"
        },
        desktop: {
            en: "Get {discount} off your first month of Scentbird"
        }
    },
    freeTrial: {
        mobile: {
            en: "Get your free perfume now"
        },
        desktop: {
            en: "Get your free perfume now. Your first month is free, just pay {extraShippingPrice} for shipping and handling"
        }
    },
    freeProduct: {
        mobile: {
            en: "Subscribe and unlock your free product"
        },
        desktop: {
            en: "Subscribe and unlock a free product in your first order"
        }
    },
    freeMonth: {
        mobile: {
            en: "Unlock your second month for free"
        },
        desktop: {
            en: "Buy one, get one free! Monthly supply of any listed fragrance starting at {price}"
        }
    },
    noDiscountText: {
        en: "Get your first month of Scentbird for {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBanner/SubscribeHeaderBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var textByOffer = {
    freeTrial: messages.freeTrial,
    free2ndMonth: messages.freeMonth,
    freeProduct: messages.freeProduct,
    discount: messages.discount
};
var SubscribeHeaderBanner = function(props) {
    var _textByOffer_offerType;
    var _props_placement = props.placement, placement = _props_placement === void 0 ? "Header" : _props_placement, withCountdown = props.withCountdown, _props_withArrow = props.withArrow, withArrow = _props_withArrow === void 0 ? true : _props_withArrow, countdownCookieName = props.countdownCookieName;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), isFetching = _useSubscribeOffer.isFetching, discountText = _useSubscribeOffer.discountText, eventDiscountText = _useSubscribeOffer.eventDiscountText, couponCode = _useSubscribeOffer.couponCode, formattedPrice = _useSubscribeOffer.formattedPrice, formattedExtraShippingPrice = _useSubscribeOffer.formattedExtraShippingPrice, offerType = _useSubscribeOffer.offerType, handleSubscribeClick = _useSubscribeOffer.handleSubscribeClick;
    var deviceType = isMobile ? "mobile" : "desktop";
    var title = _object_spread_props(_object_spread({}, ((_textByOffer_offerType = textByOffer[offerType]) === null || _textByOffer_offerType === void 0 ? void 0 : _textByOffer_offerType[deviceType]) || messages.noDiscountText), {
        values: {
            discount: discountText,
            price: formattedPrice,
            extraShippingPrice: formattedExtraShippingPrice
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBannerBase/* default */.Z, {
        title: title,
        loading: isFetching,
        withArrow: withArrow,
        withCountdown: withCountdown,
        countdownCookieName: countdownCookieName,
        trackParams: {
            placement: placement,
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: couponCode
        },
        onClick: handleSubscribeClick
    });
};
/* harmony default export */ const SubscribeHeaderBanner_SubscribeHeaderBanner = (SubscribeHeaderBanner);


/***/ }),

/***/ 23235:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBannerBase_SubscribeHeaderBannerBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(39450);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(53743);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/messages.ts
/* harmony default export */ const messages = ({
    start: {
        en: "Offer ends in"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Countdown_module = ({"seconds":"Mngfsm","milliseconds":"DIFWZO"});
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.tsx







var secondsFormat = "mm [min], ss [sec]";
var millisecondsFormat = "mm [min], ss.S [sec]";
var Countdown = function(param) {
    var cookieName = param.cookieName, _param_withMilliseconds = param.withMilliseconds, withMilliseconds = _param_withMilliseconds === void 0 ? true : _param_withMilliseconds;
    var countdownRef = (0,react.useRef)();
    var _useCountdown = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName: cookieName,
        initialTime: 20 * 60 * 1000,
        format: withMilliseconds ? millisecondsFormat : secondsFormat,
        withMilliseconds: withMilliseconds,
        message: messages.time
    }), countdownMessage = _useCountdown.countdownMessage, isExpired = _useCountdown.isExpired;
    if (isExpired) {
        return null;
    }
    var timeClassName = (0,clsx/* default */.Z)("inline-block", withMilliseconds ? Countdown_module.milliseconds : Countdown_module.seconds, withMilliseconds ? "text-black" : null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ". ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "inline-block whitespace-nowrap text-left",
                "data-testid": "timer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: messages.start
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        ref: countdownRef,
                        className: timeClassName,
                        children: countdownMessage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Countdown_Countdown = (Countdown);

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








// base banner without any logic about offer copy and countdown
var SubscribeHeaderBannerBase = function(props) {
    var title = props.title, _props_to = props.to, to = _props_to === void 0 ? links/* default */.ZP.subscribe : _props_to, trackParams = props.trackParams, loading = props.loading, onClick = props.onClick, isStatic = props.isStatic, withArrow = props.withArrow, withCountdown = props.withCountdown, withMilliseconds = props.withMilliseconds, countdownCookieName = props.countdownCookieName;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var bannerProps = {
        className: "bg-gold-50",
        height: isMobile ? 48 : 64,
        "data-testid": "subscribeBanner",
        loading: loading
    };
    if (!isStatic) {
        bannerProps.to = to;
        bannerProps.trackParams = trackParams;
        bannerProps.onClick = onClick;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, _object_spread_props(_object_spread({}, bannerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                style: isMobile ? "sh6" : "sh5",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: title
                        })
                    }),
                    withCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown_Countdown, {
                        cookieName: countdownCookieName,
                        withMilliseconds: withMilliseconds
                    })
                ]
            }),
            withArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    }));
};
/* harmony default export */ const SubscribeHeaderBannerBase_SubscribeHeaderBannerBase = (SubscribeHeaderBannerBase);


/***/ }),

/***/ 47866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ TheEditBanner_TheEditBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(76133);
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_cbfdf7.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/messages.ts
/* harmony default export */ const TheEditBanner_messages = ({
    title: {
        en: "Shop the Edit"
    },
    text: {
        en: "\n      Immerse yourself in scent<br />\n      beyond the bottle with<br />\n      candles, body lotions,<br />\n      diffusers, and so much more.\n    "
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx







var TheEditBanner = function(props) {
    var onClick = props.onClick, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "theEditBanner" : tmp, placement = props.placement;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.theEdit,
        title: TheEditBanner_messages.title,
        text: TheEditBanner_messages.text,
        textColor: "black",
        bgImage: bg_namespaceObject,
        buttonTitle: messages/* default */.Z.learnMore,
        content: "TheEdit",
        onClick: onClick,
        placement: placement,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const TheEditBanner_TheEditBanner = (TheEditBanner);


/***/ }),

/***/ 53197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31978);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16776);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23796);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21182);






var ResubscribeButton = function(props) {
    var className = props.className, _props_size = props.size, size = _props_size === void 0 ? 56 : _props_size, _props_style = props.style, style = _props_style === void 0 ? "primary" : _props_style, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, productToAdd = props.productToAdd, title = props.title, loading = props.loading, placement = props.placement, onProductAdded = props.onProductAdded, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "resubscribeButton" : tmp;
    var eventOffer = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useResubscribeOffer */ .W)().eventOffer;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        (0,analytics__WEBPACK_IMPORTED_MODULE_3__/* .track */ .j)("Banner click", {
            placement: placement,
            content: "Resubscribe",
            offer: eventOffer
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_4__/* .openModal */ .h7)("resubscribeModal", {
            productToAdd: productToAdd,
            onProductAdded: onProductAdded
        });
    }, [
        placement,
        eventOffer,
        productToAdd,
        onProductAdded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: className,
        title: title || components_inputs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.resubscribeNow,
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        "data-testid": dataTestId,
        onClick: handleClick,
        loading: loading,
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ResubscribeButton));


/***/ })

}]);